import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "customMenuItem",
  title: "Custom Menu Item",
  preview: {
    select: {
      title: "target.title",
      title2: "target.heading.title"
    },
    prepare({ title, title2 }) {
      return {
        title:
          multilingualStringPreview(title) || multilingualStringPreview(title2)
      };
    }
  },
  fields: [
    {
      type: "multilingualArrayString",
      name: "title",
      validation: (Rule) => Rule.required()
    },
    {
      type: "designSystemIcon",
      name: "icon"
    },
    {
      name: "target",
      title: "Target",
      type: "reference",
      validation: (Rule) => Rule.required(),
      to: [
        { type: "page" },
        { type: "landingPage" },
        { type: "offersTermsAndConditions" },
        { type: "exclusiveOfferPerPromo" }
      ]
    },
    {
      name: "trackingName",
      title: "Tracking Name",
      type: "string",
      validation: (Rule) => Rule.required()
    }
  ]
});
